import { ACTION_TYPES } from './index';

export const updateSearchForParticularDepartment = (payload) => {
  return {
    type: ACTION_TYPES.SEARCH_FOR_PARTICULAR_DEPARTMENT,
    payload,
  };
};

export const updateSearchWithoutCallNumber = (payload) => {
  return {
    type: ACTION_TYPES.SEARCH_WITHOUT_CALL_NUMBER,
    payload,
  };
};

export const storeDepartmentData = (payload) => {
  return {
    type: ACTION_TYPES.STORE_DEPARTMENT_DATA,
    payload,
  };
};

export const storeCompanyDetails = (payload) => {
  return {
    type: ACTION_TYPES.STORE_COMPANY_DATA,
    payload,
  };
};

export const storeFilteredCompanyDetails = (payload) => {
  return {
    type: ACTION_TYPES.STORE_FILTERED_COMPANY_DATA,
    payload,
  };
};

export const selectedDepartmentValue = (payload, actionFor) => {
  return {
    type: ACTION_TYPES.SELECTED_DEPARTMENT_NAME,
    payload,
    actionFor,
  };
};

export const selectedCompanyValue = (payload) => {
  return {
    type: ACTION_TYPES.SELECTED_COMPANY_NAME,
    payload,
  };
};

export const clearFilterData = (payload) => {
  return {
    type: ACTION_TYPES.CLEAR_FILTER,
    payload,
  };
};

export const disposeFilters =
  ({ key }) =>
  (dispatch, getState) => {
    let {
      searchFilter: { filters },
    } = getState();
    filters = filters.filter((filter) => filter.filterGroup !== key);
    return dispatch({
      type: ACTION_TYPES.DISPOSE_FILTERS,
      payload: filters,
    });
  };

export const updateFiltersState = ({ filterGroup, newState, operation }) => ({
  type: ACTION_TYPES.UPDATE_FILTERS_STATE,
  filterGroup,
  newState,
  operation,
});
